import React from 'react';
import { colors } from '../../constants/theme';
import { mockData } from '../../data/mockData';

const CategorySelector = ({ selectedCategory, onCategoryChange }) => {
  return (
    <div className="flex justify-center space-x-2 flex-wrap">
      {mockData.categories.map((category) => (
        <button
          key={category}
          onClick={() => onCategoryChange(category)}
          className={`px-4 py-2 rounded-lg font-medium mb-2 ${
            selectedCategory === category ? 'text-white' : 'bg-white text-gray-700'
          }`}
          style={{
            backgroundColor: selectedCategory === category ? colors.primary : 'white'
          }}
        >
          {category.charAt(0).toUpperCase() + category.slice(1)}
        </button>
      ))}
    </div>
  );
};

export default CategorySelector;